"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _TableRow = _interopRequireDefault(require("./TableRow"));
var _TableFooter = _interopRequireDefault(require("./TableFooter.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TableFooter = exports.TableFooter = function TableFooter(_ref) {
  var headLabels = _ref.headLabels,
    footerCells = _ref.footerCells,
    cellProps = _ref.cellProps,
    stickyFooter = _ref.stickyFooter;
  var tableKeys = Object.keys(headLabels);
  return /*#__PURE__*/_react["default"].createElement(_TableFooter["default"], {
    enableStickyFooter: stickyFooter
  }, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], null, tableKeys.map(function (key) {
    var extraProps = cellProps ? cellProps[key] : null;
    return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], _extends({
      key: "cell-".concat(key)
    }, extraProps), footerCells[key]);
  })));
};
TableFooter.propTypes = {
  headLabels: _propTypes["default"].shape({}).isRequired,
  cellProps: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({})]))),
  footerCells: _propTypes["default"].shape({}).isRequired,
  stickyFooter: _propTypes["default"].bool
};
TableFooter.defaultProps = {
  cellProps: null,
  stickyFooter: false
};
var _default = exports["default"] = TableFooter;